import { BuildFontString } from "./BuildFontString";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_Scale } from "./XML_Scale";
import { Div2Floor } from "./Div2Floor";
import { XML_AddSingle } from "./XML_AddSingle";
import { XML_ScaleFont } from "./XML_ScaleFont";
import { MeasureTextHeight } from "./MeasureTextHeight";
import { XML_AddPair } from "./XML_AddPair";
import { XML_SetTextColor } from "./XML_SetTextColor";
import { MeasureText } from "./MeasureText";
import { XML_DrawLinePDF } from "./XML_DrawLinePDF";

export function XML_DrawTextPDF(
  theMessage,
  x,
  y,
  textColor,
  fontFamily,
  fontSize,
  bold,
  italic,
  underline,
  alignment,
  vAlignment,
  clipRect,
  drawElement,
  layer
) {
  var liney = y;
  var linex = x;
  x = XML_ScaleAndShiftX(x, drawElement, layer);
  y = XML_ScaleAndShiftY(y, drawElement, layer);

  var fs = BuildFontString(fontFamily, fontSize, bold, italic);

  theMessage = drawElement.ClipText(theMessage, fs, clipRect);
  var unscaledHeight = MeasureTextHeight(fs, fontSize);
  var th = XML_Scale(unscaledHeight, drawElement, layer);

  var usingBoundRect = drawElement.UseBoundingRect();
  var dy = 0;
  var va = "";
  switch (vAlignment) {
    case "middle":
      dy = Div2Floor(th);
      va = "m";
      break;
    case "top":
      dy = th;
      va = "t";
      break;
    case "bottom":
      dy = 0;
      va = "b";
      break;
  }

  dy = Math.floor(dy * 0.75);
  y = y + dy;
  y = drawElement.ConvertY(y);

  if (clipRect) drawElement.AddClipRect(clipRect, layer);

  var s = drawElement.GetStream();
  drawElement.OutputElementHead(s, "tx");

  fontSize = XML_ScaleFont(fontSize, drawElement, layer);
  XML_AddSingle(fontSize, "s", drawElement);

  if (!bold && !italic) XML_AddSingle(fontFamily, "f", drawElement);
  else {
    var bo = bold ? "b" : "";
    var it = italic ? "i" : "";
    XML_AddPair(fontFamily, bo + it, "f", drawElement);
  }

  XML_SetTextColor(textColor, drawElement);

  var proc = "l";
  switch (alignment) {
    case "right":
      proc = "r";
      break;
    case "center":
      proc = "c";
      break;
  }
  XML_AddSingle(proc, "ta", drawElement);
  if (usingBoundRect) XML_AddSingle(va, "va", drawElement);

  if (clipRect) drawElement.AddBoundingRect(clipRect);

  if (!usingBoundRect) XML_AddPair(x, y, "tp", drawElement);
  XML_AddSingle(theMessage, "t", drawElement);
  drawElement.OutputElementTail(s, "tx");
  var width = MeasureText(theMessage, fs);
  switch (alignment) {
    case "right":
      linex = linex - width;
      break;
    case "left":
      break;
    default:
      linex = linex - width / 2;
      break;
  }
  liney += unscaledHeight * 0.8;
  if (bold)
    // factor in increased line height in the case of bold text
    liney += 0.25;
  if (underline)
    XML_DrawLinePDF(
      linex,
      liney,
      linex + width,
      liney,
      textColor,
      bold ? 1.5 : 1,
      0,
      drawElement,
      layer
    );
}
